<template>
  
  <div v-if="proceeding">
      <!-- Breadcrumb Navigation -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
        <li class="breadcrumb-item"><router-link to="/dashboard">Expedientes</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">Editar Expediente</li>
      </ol>
    </nav>
    <p><strong>Expediente:</strong> {{ proceeding.number }}</p>
    <p><strong>Descripción:</strong> {{ proceeding.description }}</p>

    <div v-if="user.id === proceeding.user_id">
      <div class="row">
        <div class="col-md-3">
          <router-link :to="{name: 'EditProceeding', params:{id: proceeding.id}}" class="btn btn-primary">Editar</router-link>
        </div>
        <div class="col-md-3">
          <button @click="removeProceeding()" class="btn btn-secondary">Eliminar</button>
        </div>
      </div>
      <!-- <p><router-link :to="{name: 'EditProceeding', params:{id: proceeding.id}}" class="btn btn-primary">Editar</router-link></p>
      <p><button @click="removeProceeding()" class="btn btn-secondary">Eliminar</button></p> -->
    </div>
  </div>
</template>


<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default defineComponent({
  name: 'Proceeding-view',
  props: ['id'],
  async created() {
    try {
      await this.viewProceeding(this.id);
    } catch (error) {
      console.error(error);
      this.$router.push('/dashboard');
    }
  },
  computed: {
    ...mapGetters({ proceeding: 'stateProceeding', user: 'stateUser'}),
  },
  methods: {
    ...mapActions(['viewProceeding', 'deleteProceeding']),
    async removeProceeding() {
      try {
        await this.deleteProceeding(this.id);
        this.$router.push('/dashboard');
      } catch (error) {
        console.error(error);
      }
    }
  },
});
</script>
<style scoped>
.breadcrumb {
  background-color: transparent;
  padding: 0;
  margin-bottom: 1rem;
}
</style>